<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => ([])
  },
  depth: {
    type: Number,
    default: 0,
  }
});

const emit = defineEmits(['selected']);

function selectedItem (item) {
  emit('selected', item);
}
</script>

<template>
  <ul
    v-if="items"
    :class="[
        {'tags-list' : depth === 0 },
        {'tags-sublist': depth > 0}
    ]"
  >
    <li
        v-for="item in items"
        :key="`tag-${item.slug}`"
    >
      <button
        type="button"
        @click="selectedItem(item)"
      >
        {{ item.name }}
      </button>

      <ListCategories
        v-if="item.children"
        :items="item.children"
        @selected="selectedItem"
        :depth="depth + 1"
      />
    </li>
  </ul>
</template>

<style scoped>

</style>
